import { useEffect } from "react";
import { AppBar } from "@mui/material";

import { useScreen, useMenu } from "hooks";

import MobileHeader from "./components/MobileHeader";
import DesktopHeader from "./components/DesktopHeader";
import Banner from "./components/Banner";
import { StyledToolbar } from "./styles";

const Header = () => {
  const { isDesktop } = useScreen();
  const { loadMenu, menuItems } = useMenu();

  useEffect(() => {
    loadMenu();
  }, []);

  return (
    <>
      <AppBar position="sticky" color="neutral">
        <StyledToolbar disableGutters>
          {isDesktop ? <Banner /> : null}
          {isDesktop ? <DesktopHeader menuItems={menuItems} /> : <MobileHeader menuItems={menuItems} />}
        </StyledToolbar>
      </AppBar>
    </>
  );
};

export default Header;
